<template>
  <div>
    <div class="content">
      <mu-content-block v-if="isLoading" style="text-align: center">
        <mu-circular-progress :size="32"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-content-block>
      <div id="lifeFavourites" v-if="!isLoading && hasFavourites">
        <mu-flexbox class="row" :gutter="16" v-for="chunks, index in chunkedItems" :key="'chunk-' + index">
          <mu-flexbox-item class="post" v-for="post, index in chunks" :key="'post-' + index">
            <mu-card>
              <router-link :to="{ name: 'LifeStyleArticle', params: { permalink: post.post_slug }}">
                <mu-card-media class="imgHolder">
                  <div class="img" v-bind:style="{ 'background-image':'url('+ post.post_image +')' }"></div>
                </mu-card-media>
                <div class="overlay">
                  <mu-flexbox justify="flex-end" align="align" class="item">
                    <h3 class="largeTitle">
                      <span v-once>{{post.post_title}}</span>
                    </h3>
                    <mu-card-text class="desc">
                      <div class="extract">
                        <div>{{post.post_excerpt}}
                          <!--<router-link class="blueTitle" :to="{ name: 'LifeStyleArticle', params: { permalink: post.post_slug }}" replace>Read more</router-link>-->
                        </div>
                      </div>
                    </mu-card-text>
                  </mu-flexbox>
                </div>
              </router-link>
              <div class="stats-bar">
                <div class="stat favourites">
                  <mu-icon-button @click.native="favouritePost(post.post_id)"
                                  :icon="post.post_favourited  ? 'favorite' : 'favorite_border'"
                                  :disabled="userId === false"/>
                  <span class="amount" v-text="post.post_favourites"></span>
                </div>
              </div>
            </mu-card>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>
      <div v-if="!isLoading && !hasFavourites">
        <p>You have favourited no articles</p>
      </div>
      <mu-content-block align="center" v-if="!isLoading && isAppending">
        <mu-circular-progress :size="32"></mu-circular-progress>
      </mu-content-block>
    </div>
  </div>
</template>

<script>
  import TitleManager from '../../../helpers/TitleManager'
  import LifeStyleApi from '../../../api/LifeStyle/index';

  export default {
    watch: {
      "$route": function() {
        let self = this;
        self.initMounted();
      }
    },
    data () {
      return {
        posts: [],
        getPostParams: {
          page: 1,
          per_page: 10,
          size: 'large',
        },
        isLoading: true,
        isPostsFinished: false,
        isAppending: false,
      }
    },
    methods: {
      loadPosts() {
        let self = this;
        self.setTitle(self.$t('message.loadingText'));
        LifeStyleApi.getMyFavouritePosts(self.$store.state.user.scope.user_id, self.getPostParams).then((response) => {
          self.setTitle(self.$t('message.lifeMyFavourites'));
          self.isLoading = false;
          let callback = response.data;
          if(callback.length) {
            if (self.getPostParams.page === 1) {
              self.posts = callback;
            } else {
              self.posts.push.apply(self.posts, callback);
              self.isAppending = false;
            }
          } else {
            self.isPostsFinished = true;
            self.isAppending = false;
          }
        });
        self.getPostParams.page += 1;
      },
      setTitle(title) {
        TitleManager.setTitle(title);
      },
      favouritePost(post_id) {
        let self = this,
          post = _.find(self.posts, ['post_id', post_id]);
        LifeStyleApi.favouritePost({
          post_id: post_id
        }).then((res) => {
          const callback = res.data;
          if (callback.fav_status) {
            post.post_favourited = true;
            post.post_favourites += 1;
          } else {
            post.post_favourited = false;
            post.post_favourites -= 1;
          }
        });
      },
      goTo(slug) {
        let self = this;
        self.$router.push({name: 'LifeStyleArticle', params: {permalink: slug}})
      },
      initScroll() {
        let self = this,
          el = self.$route.meta.id;
        $(function () {
          $('#' + el).on('scroll', function () {
            if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
              if (!self.isPostsFinished) {
                self.loadPosts();
                self.isAppending = true;
              }
            }
          });
        });
      },
      initMounted() {
        let self = this, el = self.$route.meta.id;
        self.posts = [];
        self.getPostParams.page = 1;
        self.isLoading = true;
        self.isPostsFinished = false;
        self.isAppending = false;
        setTimeout(() => {
          self.loadPosts();
        }, 1)
        self.initScroll();
      }
    },
    computed: {
      hasFavourites() {
        let self = this;
        return self.posts.length;
      },
      chunkedItems () {
        let self = this;
        return _.chunk(_.toArray(self.posts), 2);
      },
      userId() {
        let self = this;
        if (_.has(self.$store.state.user, 'scope')) {
          return self.$store.state.user.scope.user_id;
        }
        return false;
      }
    },
    mounted () {
      let self = this;
      self.initMounted();
    },
  }
</script>
<style lang="less">
   @import "./LifeFavourites.less";
</style>



// WEBPACK FOOTER //
// LifeFavourites.vue?13b176ce